import "./layout.scss"

import PropTypes from "prop-types"
import React from "react"
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles"
import NavBar from "./NavBar"
import { ParallaxProvider } from "react-scroll-parallax"
import PageTransition from "gatsby-plugin-page-transitions"
import ContactSection from "./ContactSection"
import Corner from "../images/Corner"
import useResponsive from "../utils/useResponsive"

//
//
const theme = createMuiTheme({
  typography: {
    fontFamily: ["Raleway, sans-serif"],
    h1: {
      fontSize: "4rem",
    },
    h2: {
      fontSize: "2.75rem",
    },
    h3: {
      fontFamily: ["Cinzel"],
      fontSize: "2rem",
    },
    h4: {
      fontFamily: ["Cinzel", "sans-serif"],
      fontSize: "1.3rem",
      color: "#000000a8",
    },
    body1: {
      fontSize: "15px",
    },
    button: {
      fontFamily: ["Spinnaker", "serif"],
      fontSize: "14px",
    },
  },
  palette: {
    text: {
      primary: "rgba(0,0,0,0.8)",
      secondary: "rgba(0,0,0,0.5)",
    },
  },
})

export const faintDecorColor = "rgba(256,256,256,0.4)"
const Layout = ({ children, contactInfo = true }) => {
  const { smUp } = useResponsive()
  return (
    <ThemeProvider theme={theme}>
      <ParallaxProvider>
        <NavBar />
        <PageTransition>
          <main style={{ minHeight: "calc(100vh - 14rem)" }}>{children}</main>
        </PageTransition>
        <footer
          style={{
            margin: "3rem 0 0",
            padding: "1rem 0",
            backgroundColor: "#a7cfd7",
            position: "relative",
            minHeight: "6rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              borderTop: `1px solid ${faintDecorColor}`,
              width: "100vw",
            }}
          >
            <ContactSection />

            {smUp && (
              <>
                <Corner
                  color={faintDecorColor}
                  style={{
                    bottom: 10,
                    right: 10,
                    transform: "rotate(180deg)",
                    pointerEvents: "none",
                  }}
                />

                <div
                  style={{
                    width: "calc(100vw - 220px)",
                    borderBottom: `1px solid ${faintDecorColor}`,
                    margin: "0 auto",
                  }}
                />
                <Corner
                  color={faintDecorColor}
                  style={{
                    bottom: 10,
                    left: 10,
                    transform: "rotate(-90deg)",
                    pointerEvents: "none",
                  }}
                />
              </>
            )}
          </div>
        </footer>
      </ParallaxProvider>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
